export default {"src":"/_next/static/media/warning.8d7ffe0f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};